import signinSet from '../components/signinSet.vue';
import Counter from '../components/counter.vue';
import signinResult from '../components/signinResult.vue';
import TimerSignBoard from '../components/TimerSignBoard.vue';
import SignList from '../components/SignList.vue';
import { useSignServer, useChatServer } from 'middle-domain';
import to from 'await-to-js';

export default {
  components: {
    signinSet,
    Counter,
    signinResult,
    TimerSignBoard,
    SignList
  },
  data() {
    return {
      signVisible: false, // 是否显示签到设置(创建)对话框
      signinDown: false, // 是否显示签到倒计时或签到设置结果对话框
      signListVisible: false, // 签到记录对话框(当前只显示定时签到记录)
      signInfo: null, // 签到信息

      remaining: 0, // 签到剩余时长
      timer: null // 计时器id
    };
  },
  computed: {
    // 当前正在进行的签到
    doingSign() {
      return this.signInfo?.doing_sign?.id ? this.signInfo.doing_sign : null;
    },
    // 定时签到还未推送的时间集合
    notPushedTimes() {
      return this.signInfo?.un_pushed_sign_list?.map(item => item.push_time) || [];
    },
    // 展示签到计时界面
    showCounter() {
      return this.doingSign !== null && this.remaining > 0;
    },
    // 签到结果
    showResult() {
      return this.doingSign !== null && !this.remaining && !this.signInfo.is_auto_sign !== 1;
    },
    // 展示定时签到设置的信息面板
    showTimerSignBoard() {
      return this.doingSign === null && this.notPushedTimes.length > 0;
    },
    // 本次签到时长
    total() {
      if (this.doingSign) {
        // 如果开启了自动循环签到，时长取循环间隔时间
        return this.doingSign.is_auto_sign == 1
          ? this.doingSign.auto_sign_time
          : this.doingSign.show_time;
      }
      return 0;
    },
    roomId() {
      return this.$domainStore.state.roomBaseServer.watchInitData.interact.room_id;
    },
    webinarId() {
      return this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.id;
    }
  },
  methods: {
    handleSign(flag) {
      flag ? this.openSign() : this.closeSign();
    },
    openSign() {
      // 是否发起了签到
      this.getSignInfo();
    },
    closeSign() {
      this.signVisible = false;
    },
    async getSignInfo() {
      const params = { webinar_id: this.webinarId };
      const [err, res] = await to(this.signServer.fetchSignInfo(params));
      if (err || !res || res.code != 200 || !res.data) {
        this.$message.error(err?.msg || res?.msg || '请求失败');
        return;
      }
      this.signInfo = res.data;
      this.signListVisible = false;
      if (this.signInfo?.doing_sign?.id) {
        // 有正在进行中的签到
        console.log('sign: 有正在进行中的签到');
        this.signVisible = false;
        this.signinDown = true;
        if (this.signInfo.doing_sign.is_auto_sign == 1) {
          window.sessionStorage.setItem('isAutoSign', 'true');
          this.remaining = this.signInfo.doing_sign.auto_sign_time_ttl;
        } else {
          this.remaining = this.signInfo.doing_sign.sign_time_ttl;
        }
        this.setIntervalAction();
      } else if (this.signInfo?.un_pushed_sign_list?.length > 0) {
        console.log('sign: 有未推送的签到');
        // 有未推送的签到(一定是定时签到)
        this.signVisible = false;
        this.signinDown = true;
      } else {
        // 没有任何签到信息，展示签到设置对话框
        this.signInfo = null;
        this.signVisible = true;
        this.signinDown = false;
        this.remaining = 0;
        this.timer && clearInterval(this.timer);
      }
    },
    // 倒计时
    setIntervalAction() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (--this.remaining <= 0) {
          if (sessionStorage.getItem('isAutoSign')) {
            this.remaining = this.doingSign.auto_sign_time;
            this.signVisible = false;
            this.signinDown = true;
          } else {
            clearInterval(this.timer);
          }
        }
      }, 1000);
      this.$once('hook:beforeDestory', () => {
        clearInterval(this.timer);
      });
    },
    // 开始签到按钮
    startSign(state) {
      const params = {
        webinar_id: this.webinarId,
        sign_tips: state.signTip, // 签到提示语
        show_time: state.duration, // 签到显示时长
        is_auto_sign: Number(state.autoSign), // 是否自动循环发起签到：1.是，0.否，默认0
        auto_sign_time: state.interval, // 自动循环发起签到的间隔时间，单位秒，默认900，is_auto_sign=1时需要此字段
        auto_kick_unsigned: state.auto_kick_unsigned, // 是否开启未签到用户自动踢出：1.开启，0.不开启
        sign_in_success_tips: state.signInsuccessTips, // 签到成功提示语
        push_type: state.pushType, // 推送方式：0.手动推送，1.定时推送，默认0
        push_times: state.push_times,
        sound_status: state.sound_status // 是否开启提示音效：1.是，0.否
      };
      this.signServer.createSign(params).then(res => {
        console.log('res:', res);
        if (res.code == 200) {
          if (state.pushType == 1) {
            // 定时签到
            this.getSignInfo();
            return;
          } else {
            // 手动签到,会收到签到消息, 并调用接口获取签到信息
            this.reportSign(state);
            this.signinDown = true;
            this.signVisible = false;
            window.VhallDataAgent.track('interact_publish_response', {
              button_type: 'sign_in',
              button_biz_id: res.data.id,
              is_success: 1
            });
          }
        } else if (res.code == 513204) {
          // 当前活动已签到中！
          this.openSign();
        } else {
          this.$message.error(res.msg);
        }
        if (res.code != 200) {
          window.VhallDataAgent.track('interact_publish_response', {
            button_type: 'sign_in',
            button_biz_id: res.data.id,
            is_success: 0,
            fail_reason: res.code
          });
        }
      });
    },
    // 数据埋点
    reportSign(state) {
      window.vhallReportForProduct && window.vhallReportForProduct.report(110039);
      window.vhallReportForProduct &&
        window.vhallReportForProduct.report(state.autoSign ? 110040 : 110041);
      if (state.signTip != '主持人发起了签到') {
        window.vhallReportForProduct && window.vhallReportForProduct.report(110042);
      }
      const duration = [10, 30, 60, 120, 180];
      const index = duration.indexOf(state.duration);
      const signType = [110043, 110044, 110045, 110046, 110047];
      window.vhallReportForProduct && window.vhallReportForProduct.report(signType[index]);
      if (state.autoSign) {
        const interval = [60, 300, 900, 1800];
        const indexs = interval.indexOf(state.interval);
        const intervalType = [110048, 110049, 110050, 110051];
        window.vhallReportForProduct && window.vhallReportForProduct.report(intervalType[indexs]);
      }
    },
    // 结束签到
    endSignServe() {
      this.signServer
        .signClose({
          room_id: this.roomId,
          sign_id: this.doingSign.id
        })
        .then(res => {
          this.$message.success(`${this.$t('host.k_597001')}`);
          window.sessionStorage.removeItem('isAutoSign');
          if (this.doing_sign.is_auto_sign == 1) {
            this.signVisible = false;
            this.signinDown = false;
            this.signInfo = null;
            if (this.isLeleMode) {
              this.openSign();
            }
          }
          this.remaining = 0;
          this.timer && clearInterval(this.timer);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    // 设置签到信息和状态
    setSignState(state) {
      this.signInfo = state.signInfo;
      this.remaining = state.remaining ? state.remaining : this.total;
    },
    // 重新开始签到
    restartSign() {
      this.getSignInfo();
    },
    // 关闭签到
    closeAutoSignin(form) {
      if (form == 'client') {
        // 客户端走的方法
        this.signVisible = false;
        return;
      }
      this.$vhConfirm(
        this.doingSign.is_auto_sign == 1
          ? `${this.$t('host.k_597002')}`
          : `${this.$t('host.k_597003')}`,
        `${this.$t('host.k_597004')}`,
        {
          confirmButtonText: `${this.$t('host.k_597005')}`,
          cancelButtonText: `${this.$t('host.k_597006')}`,
          roundButton: true
        }
      )
        .then(() => {
          this.endSignServe();
        })
        .catch(() => {});
    },
    // 收到“签到推送“消息处理
    handleSigninPush(e) {
      this.getSignInfo();
      const data = {
        roleName: e.data.role_name,
        nickname: e.data.sign_creator_nickname,
        avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
        content: {
          text_content: `${this.$t('chat.chat_1027')}`
        },
        type: e.data.type,
        interactStatus: true
      };
      useChatServer().addChatToList(data);
    },
    // 签到结束处理
    handleSignEnd(e) {
      window.sessionStorage.removeItem('isAutoSign');
      this.remaining = 0;
      clearInterval(this.timer);
      const data = {
        roleName: e.data.role_name,
        nickname: e.data.sign_creator_nickname,
        avatar: '//cnstatic01.e.vhall.com/static/images/watch/system.png',
        content: {
          text_content: `${this.$t('chat.chat_1028')}`
        },
        type: e.data.type,
        interactStatus: true
      };
      useChatServer().addChatToList(data);
    },
    // 直播结束处理
    handleLiveOver() {
      this.signVisible = false;
      this.signinDown = false;
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.isLeleMode) {
        this.openSign();
      }
    },
    handleViewRecord() {
      this.signListVisible = true;
    },
    handleToCreate() {
      this.signinDown = false;
      this.signListVisible = false;
      this.signInfo = null;
      this.signVisible = true;
    }
  },
  beforeCreate() {
    this.signServer = useSignServer();
  },
  mounted() {
    this.signServer.$on('sign_in_push', this.handleSigninPush);
    this.signServer.$on('sign_end', this.handleSignEnd);
    this.signServer.$on('live_over', this.handleLiveOver);
  },
  beforeDestroy() {
    this.signServer.$off('sign_in_push', this.handleSigninPush);
    this.signServer.$off('sign_end', this.handleSignEnd);
    this.signServer.$off('live_over', this.handleLiveOver);
  }
};
